import WFS, { WriteTransactionOptions } from 'ol/format/WFS';
import GML from 'ol/format/GML';
import $ from 'jquery';
import { XMLParser } from 'fast-xml-parser';

const ERROR_PREFIX = "[WFS Transaction] ";
const formatWFS = new WFS({ version: "2.0.0" });

const createformatGML = function (featureNS, featureType) {
    let formatGML = new GML({
        featureNS: featureNS,
        featureType: featureType,
        srsName: 'EPSG:3857'
    });
    return formatGML
}

// DEFINITION OF WFS 2.0 TRANSACTION PAYLOADS
const wfsSchemaRef = `version="2.0.2" service="WFS" xmlns="http://www.opengis.net/wfs" xmlns:fes="http://www.opengis.net/fes/2.0" xmlns:wfs="http://www.opengis.net/wfs/2.0" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.opengis.net/wfs/2.0 http://schemas.opengis.net/wfs/2.0/wfs.xsd"`;
const xs = new XMLSerializer();

const createInsertPayload = function (layerName, xmlToEncode) {
    let $xml = $(xmlToEncode);
    let inserts = "";
    // iterates over <Insert> elements and copies them to template
    $xml.find("Insert").each(function (i, e) {
        let insertStr = xs.serializeToString(e);
        inserts += insertStr;
    });
    let insertPayload = `<wfs:Transaction ${wfsSchemaRef}>${inserts}</wfs:Transaction>`;
    return insertPayload;
};

const createUpdatePayload = function (layerName, xmlToEncode) {
    let $xml = $(xmlToEncode);
    let updates = "";
    // iterates over <Update> elements and gets properties and filters
    $xml.find("Update").each(function (i, upd) {
        let properties = "",
            filter = "";
        $(upd).find("Property").each(function (i, e) {
            let propName = $(e).children("Name").text();
            if (propName != "boundedBy") {
                let propValue = $(e).children("Value")[0].innerHTML;
                let propStr = `<wfs:Property><wfs:ValueReference>${propName}</wfs:ValueReference><wfs:Value>${propValue}</wfs:Value></wfs:Property>`;
                properties += propStr;
            }
        });
        $(upd).find("Filter").each(function (i, e) {
            let fid = $(e).children("FeatureId").attr("fid");
            let filterStr = `<fes:Filter><fes:ResourceId rid="${fid}"/></fes:Filter>`;
            filter += filterStr;
        });
        let updateItem = `<wfs:Update typeName="${layerName}">${properties}${filter}</wfs:Update>`;
        updates += updateItem;
    });
    let updatePayload = `<wfs:Transaction ${wfsSchemaRef}>${updates}</wfs:Transaction>`;
    return updatePayload;
};

const createDeletePayload = function (layerName, xmlToEncode) {
    let $xml = $(xmlToEncode);
    let filterResIds = "";
    // iterates over <Delete> elements and gets only filters
    $xml.find("Delete").each(function (i, del) {
        $(del).find("Filter").each(function (i, e) {
            let fid = $(e).children("FeatureId").attr("fid");
            let filterResIdStr = `<fes:ResourceId rid="${fid}"/>`;
            filterResIds += filterResIdStr;
        });
    });
    let deletes = `<wfs:Delete typeName="${layerName}"><fes:Filter>${filterResIds}</fes:Filter></wfs:Delete>`;
    let deletePayload = `<wfs:Transaction ${wfsSchemaRef}>${deletes}</wfs:Transaction>`;
    return deletePayload;
};

// TRANSACTION FUNCTION

const transactWFS = function (params) {

    let rules = { "mode": "req", "features": "req", "layerCompleteName": "req", "serverUrl": "req" };
    // if (!checkParams(params, rules)) {
    //     return false;
    // }
    let mode = params.mode;
    let features = params.features;
    let layerCompleteName = params.layerCompleteName;
    let serverUrl = params.serverUrl;
    let callback = params.callback;

    let namesForGML = layerCompleteName.split(":");
    let formatGML = createformatGML(namesForGML[0], namesForGML[1]);
    var node;
    var payload;
    switch (mode) {
        case 'insert':
            //@ts-ignore
            node = formatWFS.writeTransaction(features, null, null, formatGML);
            payload = createInsertPayload(layerCompleteName, node);
            break;
        case 'update':
            //@ts-ignore
            node = formatWFS.writeTransaction(null, features, null, formatGML);
            payload = createUpdatePayload(layerCompleteName, node);
            break;
        case 'delete':
            //@ts-ignore
            node = formatWFS.writeTransaction(null, null, features, formatGML);
            payload = createDeletePayload(layerCompleteName, node);
            break;
    }

    return $.ajax(`${serverUrl}/ows`, {
        type: 'POST',
        processData: false,
        contentType: 'xml',
        dataType: 'xml',
        data: payload
    }).done(function (res) {
        console.log('DONE', res)
        callback(res);
    }).fail(function (r) {
        console.log('ERROR', r)
        return r;
    });

};

const checkParams = function (p, r) {
    let check = true;
    let notDef = [];
    $.each(r, function (k, el) {
        if (el === "req" && typeof p[k] === 'undefined') {
            notDef.push(k);
            check = false;
        }
    });
    if (!check) console.error(`${ERROR_PREFIX} ${notDef.join(', ')} not found`);
    return check;
}


export default transactWFS;